import { Component, OnDestroy, OnInit, } from '@angular/core';
import { FlotChartDirective } from '../../components/charts/flotChart';
import { PersonalService } from '../../services/personal.service';
import { ResuLiquidacionService } from '../../services/resu_liquidacion.service';
import { AusentismosService } from '../../services/ausentismos.service';
import { DatosOrganizativosService } from '../../services/datosOrganizativos.service';
import * as moment from 'moment';
import { MomentSetService } from '../../core/services/moment-set.service';

declare var jQuery:any;

@Component({
  selector: 'dashboard2',
  templateUrl: 'dashboard2.template.html'
})

export class Dashboard2Component implements OnDestroy, OnInit {

  todos: any;
  fechaHoy: Date = new Date();
  fechaCumple: Date = new Date();
  fechaAlta: Date = new Date();
  personalList: any;
  cumpleaniosList: any;
  altasList: any;
  liquidacionesList: any;
  totalEmpleados: number;
  totalSalario: number = 0;
  totalAusentismosM: number = 0;
  totalAusentismosA: number = 0;
  totalAltas: number = 0;
  tipoCuadro: number = 1;
  empleados: any;
  salarios: any;
  flotDataset: any;
  flotOptions: any;
  flotOptions2: any;
  sumSalario: number = 0;
  sumEmpleados: number = 0;
  promedioMensual: number = 0;
  anioActual: number;

  public constructor(private personalService: PersonalService,
                     private resultService: ResuLiquidacionService,
                     private ausentismoService: AusentismosService,
                     private datosOService: DatosOrganizativosService,
                     private momentService: MomentSetService) 
  {

  }

  public ngOnInit():any {
    this.fechaCumple.setDate(this.fechaCumple.getDate() + 15);
    this.fechaAlta.setDate(this.fechaAlta.getDate() - 30);

    this.fechaHoy.setHours(0,0,0,0);
    this.fechaCumple.setHours(0,0,0,0);
    this.fechaAlta.setHours(0,0,0,0);
        
    this.anioActual = this.fechaHoy.getFullYear();
    this.inicializarGrafico();
    this.inicializarTareas();
    
    let primerDiaMes = new Date(this.fechaHoy.getFullYear(), this.fechaHoy.getMonth(), 1);
    let ultimoDiaMes = new Date(this.fechaHoy.getFullYear(), this.fechaHoy.getMonth() + 1, 0);
    let primerDiaAnio = new Date(this.fechaHoy.getFullYear(), 0, 1);
    let ultimoDiaAnio = new Date(this.fechaHoy.getFullYear(), 12, 0);
    
    this.personalService.getIndex().subscribe(
      data =>{ 
        data.forEach((currentValue,index,arr) => {
          currentValue.liquidarDesde = this.momentService.convertDateServer(currentValue.liquidarDesde);
          currentValue.liquidarHasta = this.momentService.convertDateServer(currentValue.liquidarHasta);
          currentValue.fechaNacimiento = this.momentService.convertDateServer(currentValue.fechaNacimiento);
        });
        this.personalList = data;
        this.totalEmpleados = data.filter(i => (i.liquidarHasta == null || Date.parse(i.liquidarHasta) >= this.fechaHoy.getTime()) 
                                          && (i.liquidarDesde == null || Date.parse(i.liquidarDesde) <= this.fechaHoy.getTime())
                                          && (i.bloqueado == null || i.bloqueado == 0) ).length;
        
        this.calcEmpleados(primerDiaAnio, 12, 1);
        this.listaCumpleanios(data);
      }
    );

    this.resultService.GetUltimoPeriodo("N", this.fechaHoy.toDateString()).subscribe(
      data =>{ 
        data.forEach((currentValue,index,arr) => {
          currentValue.fechaPago = this.momentService.convertDateServer(currentValue.fechaPago);
        });
        this.liquidacionesList = data;
        this.calcSalarios(primerDiaAnio, 12, 1);
      }
    );

    this.resultService.GetUltimoPeriodo("S", this.fechaHoy.toDateString()).subscribe(
      data =>{ 
        let liquidaciones = data;
        for(let i=0; i<liquidaciones.length;i++){
          for(let j=0; j<liquidaciones[i].resultPayrollDet.length;j++){
            if(liquidaciones[i].resultPayrollDet[j].codigosNominaNavigation.columnaRecibo == 1 ||
               liquidaciones[i].resultPayrollDet[j].codigosNominaNavigation.columnaRecibo == 2 )
            {
              this.totalSalario = this.totalSalario + liquidaciones[i].resultPayrollDet[j].importe;
            }
          }
        }
      }
    );

    this.ausentismoService.GetCantidadByPeriodo(primerDiaMes.toDateString(), ultimoDiaMes.toDateString()).subscribe(
      data =>{ 
        this.totalAusentismosM = data;
      }
    );
    this.ausentismoService.GetCantidadByPeriodo(primerDiaAnio.toDateString(), ultimoDiaAnio.toDateString()).subscribe(
      data =>{ 
        this.totalAusentismosA = data;
      }
    );

    this.datosOService.getList().subscribe(
      data =>{ 
        data.forEach((currentValue,index,arr) => {
          currentValue.desde = this.momentService.convertDateServer(currentValue.desde);
          currentValue.hasta = this.momentService.convertDateServer(currentValue.hasta);
        });
        this.altasList = data.filter(i => (Date.parse(i.desde) >= this.fechaAlta.getTime()) 
                                          && (Date.parse(i.desde) <= this.fechaHoy.getTime()));
        
        this.altasList.sort((a, b) => new Date(b.desde).getTime() - new Date(a.desde).getTime());
        this.totalAltas = this.altasList.length;
      }
    );

  }

  public ngOnDestroy():any {
  }

  private gd(year, month, day) {
    return new Date(year, month - 1, day).getTime();
  }

  listaCumpleanios(empleados) : void
  {
    this.cumpleaniosList = [];
    let anio = this.fechaHoy.getFullYear();

    for(let i=0; i<empleados.length; i++)
    {
      let fcumple = new Date(empleados[i].fechaNacimiento);
      let mes = fcumple.getMonth();
      let dia = fcumple.getDate();
      let cumpleanios = new Date(anio, mes, dia, 0,0,0,0);
      if(cumpleanios.getTime() >= this.fechaHoy.getTime() && cumpleanios.getTime() <= this.fechaCumple.getTime() )
      {
        let edad = moment().diff(empleados[i].fechaNacimiento, 'years') + 1;
        if (cumpleanios.getTime() == this.fechaHoy.getTime()) 
        {
          empleados[i].interno = "S";
          edad -= 1;
        }
        empleados[i].titulo = edad;             //Para mostrar cuantos años cumple
        empleados[i].celular = cumpleanios;         //Para ordenar por cumpleaños y mostrar que dia cae
        this.cumpleaniosList.push(empleados[i]);
      }
    }
    
    if(this.cumpleaniosList.length > 0)
    { 
      this.cumpleaniosList.sort((a, b) => new Date(a.celular).getTime() - new Date(b.celular).getTime());
    }
  }

  calcEmpleados(fechaIni, meses, anios) :void
  {
    this.sumEmpleados = 0;
    this.empleados = [];
    let anio = fechaIni.getFullYear();
    let mes = fechaIni.getMonth();
    let primerDia = fechaIni;
    let ultimoDia = new Date(anio, mes + 1, 0);
    for(let h=1; h<=anios; h++){
      for(let i=1; i<=meses; i++){
        let personal = this.personalList.filter(i => (i.liquidarHasta == null || Date.parse(i.liquidarHasta) >= primerDia.getTime()) 
                                                  && (i.liquidarDesde == null || Date.parse(i.liquidarDesde) <= ultimoDia.getTime())
                                                  && (i.bloqueado == null || i.bloqueado == 0) ).length;
        
        if (personal > this.sumEmpleados) this.sumEmpleados = personal;
        let periodo = [primerDia.getTime(), personal];
        this.empleados.push(periodo);
        primerDia = new Date(anio, mes + i, 1);
        ultimoDia = new Date(anio, mes + 1 + i, 0);
      }

      anio = anio + 1;
      mes = 0;
      primerDia = new Date(anio, mes, 1);
      ultimoDia = new Date(anio, mes + 1, 0);
    }

    this.armarGrafico();
  }

  calcSalarios(fechaIni, meses, anios) :void
  {
    this.sumSalario = 0;
    this.promedioMensual = 0;
    let sumMeses = 0;
    this.salarios = [];
    let anio = fechaIni.getFullYear();
    let mes = fechaIni.getMonth();
    let primerDia = fechaIni;
    let ultimoDia = new Date(anio, mes + 1, 0);
    for(let h=1; h<=anios; h++){
      for(let i=1; i<=meses; i++){
        let sueldo = 0;
        let liquidaciones = this.liquidacionesList.filter(a => (Date.parse(a.fechaPago) >= primerDia.getTime()) 
                                                     && (Date.parse(a.fechaPago) <= ultimoDia.getTime())
                                                     && (a.tipoLiquidacion != "E"));
  
        for(let j=0; j<liquidaciones.length;j++){
          for(let k=0; k<liquidaciones[j].resultPayrollDet.length;k++){
            if(liquidaciones[j].resultPayrollDet[k].codigosNominaNavigation.columnaRecibo == 1 ||
               liquidaciones[j].resultPayrollDet[k].codigosNominaNavigation.columnaRecibo == 2 )
            {
              sueldo += liquidaciones[j].resultPayrollDet[k].importe;
            }
          }
        }
        if (sueldo > 0) sumMeses += 1;
        this.sumSalario += sueldo;
        let periodo = [primerDia.getTime(), sueldo];
        this.salarios.push(periodo);
        primerDia = new Date(anio, mes + i, 1);
        ultimoDia = new Date(anio, mes + 1 + i, 0);
      }

      anio = anio + 1;
      mes = 0;
      primerDia = new Date(anio, mes, 1);
      ultimoDia = new Date(anio, mes + 1, 0);
    }
    if (sumMeses == 0) sumMeses = 1;
    this.promedioMensual = this.sumSalario / sumMeses;
    this.armarGrafico();
  }

  cuadroAnioActual()
  {
    this.tipoCuadro = 1;
    let primerDiaAnio = new Date(this.fechaHoy.getFullYear(), 0, 1);
    this.calcEmpleados(primerDiaAnio, 12, 1);
    this.calcSalarios(primerDiaAnio, 12, 1);
  }
  cuadroAnioAnterior()
  {
    this.tipoCuadro = 2;
    let primerDiaAnio = new Date(this.fechaHoy.getFullYear() - 1, 0, 1);
    this.calcEmpleados(primerDiaAnio, 12, 1);
    this.calcSalarios(primerDiaAnio, 12, 1);
  }
  cuadroCincoAnios()
  {
    this.tipoCuadro = 3;
    let primerDiaAnio = new Date(this.fechaHoy.getFullYear() - 4, 0, 1);
    this.calcEmpleados(primerDiaAnio, 12, 5);
    this.calcSalarios(primerDiaAnio, 12, 5);
  }

  armarGrafico()
  {
    this.flotDataset = [
      {
        label: "Bruto Pagado",
        data: this.salarios,
        color: "#1ab394",
        bars: {
          show: true,
          align: "center",
          barWidth: 20 * 24 * 60 * 60 * 1000,
          lineWidth: 0
        }  
      }, 
      {
        label: "Empleados Activos",
        data: this.empleados,
        yaxis: 2,
        color: "#1C84C6",
        lines: {
          lineWidth: 1,
          show: true,
          fill: true,
          fillColor: {
            colors: [{
              opacity: 0.2
            }, {
              opacity: 0.6
            }]
          }
        },
        splines: {
          show: false,
          tension: 0.6,
          lineWidth: 1,
          fill: 0.1
        },
      }
    ];

    this.flotOptions =
    {
      colors: ["#1ab394", "#1C84C6"],
      tooltip: true,
      xaxis: {
        mode: "time",
        tickSize: [1, "month"],
        tickLength: 0,
        axisLabel: "Date",
        axisLabelUseCanvas: true,
        axisLabelFontSizePixels: 12,
        axisLabelFontFamily: 'Arial',
        axisLabelPadding: 10,
        color: "#d5d5d5"
      },
      yaxes: [{
        position: "left",
        color: "#d5d5d5",
        axisLabelUseCanvas: true,
        axisLabelFontSizePixels: 12,
        axisLabelFontFamily: 'Arial',
        axisLabelPadding: 3
      }, 
      {
        position: "right",
        color: "#d5d5d5",
        //max: this.empleados.length * 1.5,
        axisLabelUseCanvas: true,
        axisLabelFontSizePixels: 12,
        axisLabelFontFamily: ' Arial',
        axisLabelPadding: 67
      }
      ],
      legend: {
        noColumns: 2,
        labelBoxBorderColor: "#000000",
        position: "nw",
        margin:[20 , -60]
      },
      grid: {
        hoverable: true,
        clickable: false,
        borderWidth: 0,
      }
    };

    this.flotOptions2 =
    {
      colors: ["#1ab394", "#1C84C6"],
      tooltip: true,
      xaxis: {
        mode: "time",
        tickSize: [6, "month"],
        tickLength: 0,
        axisLabel: "Date",
        axisLabelUseCanvas: true,
        axisLabelFontSizePixels: 12,
        axisLabelFontFamily: 'Arial',
        axisLabelPadding: 10,
        color: "#d5d5d5"
      },
      yaxes: [{
        position: "left",
        color: "#d5d5d5",
        axisLabelUseCanvas: true,
        axisLabelFontSizePixels: 12,
        axisLabelFontFamily: 'Arial',
        axisLabelPadding: 3
      }, 
      {
        position: "right",
        color: "#d5d5d5",
        // max: this.empleados.length * 1.5,
        axisLabelUseCanvas: true,
        axisLabelFontSizePixels: 12,
        axisLabelFontFamily: ' Arial',
        axisLabelPadding: 67
      }
      ],
      legend: {
        noColumns: 2,
        labelBoxBorderColor: "#000000",
        position: "nw",
        margin:[20 , -60]
      },
      grid: {
        hoverable: true,
        clickable: false,
        borderWidth: 0,
      }
    };

  }
  
  public mapOptions:any = {
    map: 'world_mill_en',
    backgroundColor: "transparent",
    regionStyle: {
      initial: {
        fill: '#e4e4e4',
        "fill-opacity": 0.9,
        stroke: 'none',
        "stroke-width": 0,
        "stroke-opacity": 0
      }
    },
    series: {
      regions: [{
        values: {
          "US": 298,
          "SA": 200,
          "DE": 220,
          "FR": 540,
          "CN": 120,
          "AU": 760,
          "BR": 550,
          "IN": 200,
          "GB": 120
        },
        scale: ["#1ab394", "#22d6b1"],
        normalizeFunction: 'polynomial'
      }]
    },
  }

  inicializarGrafico()
  {
    this.empleados = [
      [this.gd(2022, 1, 1), 5], [this.gd(2022, 2, 1), 6], [this.gd(2022, 3, 1), 6], 
      [this.gd(2022, 4, 1), 8], [this.gd(2022, 5, 1), 9], [this.gd(2022, 6, 1), 9], 
      [this.gd(2022, 7, 1), 9], [this.gd(2022, 8, 1), 9], [this.gd(2022, 9, 1), 9], 
      [this.gd(2022, 10, 1), 10], [this.gd(2022, 11, 1), 10], [this.gd(2022, 12, 1), 11]
    ];
    this.salarios = [
      [this.gd(2022, 1, 1), 85000], [this.gd(2022, 2, 1), 125000], [this.gd(2022, 3, 1), 135000], 
      [this.gd(2022, 4, 1), 144000], [this.gd(2022, 5, 1), 148000], [this.gd(2022, 6, 1), 155000], 
      [this.gd(2022, 7, 1), 158000], [this.gd(2022, 8, 1), 160000], [this.gd(2022, 9, 1), 161000], 
      [this.gd(2022, 10, 1), 172000], [this.gd(2022, 11, 1), 174000], [this.gd(2022, 12, 1), 180000]
    ];
    this.armarGrafico();
  }

  inicializarTareas()
  {
    this.todos = [
      {name: "Buy a milk", completed: true},
      {name: "Go to shop and find some products.", completed: false},
      {name: "Send documents to Mike ", completed: false, time: 1},
      {name: "Go to the doctor dr Smith", completed: false},
      {name: "Plan vacation", completed: true},
      {name: "Create new stuff", completed: false},
      {name: "Call to Anna for dinner", completed: false},
    ];
  }

}
